import { render, staticRenderFns } from "./weightRepInput.vue?vue&type=template&id=524174eb&scoped=true"
import script from "./weightRepInput.vue?vue&type=script&lang=js"
export * from "./weightRepInput.vue?vue&type=script&lang=js"
import style0 from "./weightRepInput.vue?vue&type=style&index=0&id=524174eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524174eb",
  null
  
)

export default component.exports